/*
 * FRENESI — Página do decant no novo visual (19/10/2026). sections/fv-produto.
 *
 * Um tamanho escolhido, marcado em todo lugar: os botões de volume, o frasco da
 * galeria, a pílula de borrifadas, os preços, o quadro «Quanto rende cada
 * tamanho» (clicar num frasco ou num botão de lá troca o volume lá em cima) e
 * a barra de compra do celular. A variante vai para o formulário do tema, que
 * põe na sacola, e para o endereço (?variant=).
 *
 * Perfil e pirâmide: assets/fv-piramides.json (curadoria do ERP), por handle.
 *
 * [dono, 20/10] Também no perfume lacrado (data-tipo="lacrado"): os tamanhos
 * são as variantes dele, cada uma com o próprio rótulo («100 ml»), sem frasco
 * de decant nem borrifadas.
 */
(() => {
  const raiz = document.querySelector('[data-fv-produto]');
  if (!raiz || raiz.dataset.fvPronto) return;
  raiz.dataset.fvPronto = '1';
  const LACRADO = raiz.dataset.tipo === 'lacrado';

  let tams = [];
  try {
    tams = JSON.parse(raiz.querySelector('[data-fv-tamanhos]').textContent);
  } catch (erro) {
    return;
  }

  const DOSES = [
    { ml: '3 ml', borr: '40 a 45 borrifadas', frasco: '8 ml', grande: 96, y: 132.9, h: 70.1 },
    { ml: '5 ml', borr: '60 a 65 borrifadas', frasco: '8 ml', grande: 96, y: 86.1, h: 116.9 },
    { ml: '8 ml', borr: '105 a 110 borrifadas', frasco: '8 ml', grande: 96, y: 15.9, h: 187.1 },
    { ml: '10 ml', borr: '135 a 140 borrifadas', frasco: '15 ml', grande: 118, y: 78.3, h: 124.7 },
    { ml: '15 ml', borr: '185 a 190 borrifadas', frasco: '15 ml', grande: 118, y: 15.9, h: 187.1 },
  ];
  const PIX = 10;
  const PARCELAS = 6;

  const real = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  const brl = (centavos) => real.format(centavos / 100).replace(/ /g, ' ');
  const noPix = (p) => Math.round((p * (100 - PIX)) / 100);
  const todos = (sel) => raiz.querySelectorAll(sel);
  const texto = (sel, valor) => todos(sel).forEach((el) => { el.textContent = valor; });

  /* ── Preço de cada tamanho nos botões ──────────────────────────────────── */
  /* [dono, 20/10] O tamanho esgotado também se escolhe: ele mostra o preço,
     o botão vira «Avise-me quando disponível» e a caixa abre com esse tamanho
     já marcado (assets/frenesi-avise.js lê o data-variante do botão). */
  todos('.fv-pdp__tam').forEach((b, i) => {
    const t = tams[i];
    const preco = b.querySelector('[data-fv-tam-preco]');
    if (!t || !t.v) {
      b.hidden = true;
      return;
    }
    if (preco) preco.textContent = t.ok ? brl(noPix(t.p)) : 'esgotado';
    b.toggleAttribute('data-esgotado', !t.ok);
  });
  todos('.fv-pdp__rende-botao').forEach((b, i) => {
    const t = tams[i];
    const preco = b.querySelector('[data-fv-rende-preco]');
    if (preco) preco.textContent = t && t.v ? (t.ok ? `${brl(noPix(t.p))} no Pix` : 'esgotado') : 'indisponível';
    if (!t || !t.v) b.disabled = true;
    else b.toggleAttribute('data-esgotado', !t.ok);
  });
  // [dono, 21/10] Os tamanhos da barra de compra do computador, em botões.
  todos('.fv-pdp__barra-pilula').forEach((b, i) => {
    const t = tams[i];
    if (!t || !t.v) {
      b.hidden = true;
      return;
    }
    b.toggleAttribute('data-esgotado', !t.ok);
    if (!t.ok) b.title = 'Esgotado: avise-me quando chegar';
  });
  todos('[data-fv-select] option').forEach((o, i) => {
    const t = tams[i];
    if (!t || !t.v) o.remove();
    else if (!t.ok) o.textContent = `${o.textContent} · esgotado`;
  });

  /* Esgotado: a compra sai e o aviso entra, com o tamanho escolhido. À venda:
     a compra volta e o aviso dos outros tamanhos fica no link discreto. */
  function mostrarAviso(t) {
    const avise = raiz.querySelector('.fv-pdp__avise');
    if (avise) {
      avise.hidden = t.ok;
      avise.setAttribute('data-variante', String(t.v));
    }
    const link = raiz.querySelector('.fv-pdp__avise-link');
    if (link) link.hidden = !t.ok;
    const botao = raiz.querySelector('[data-fv-adicionar]');
    if (botao) botao.disabled = !t.ok;
    texto('[data-fv-adicionar-texto]', t.ok ? 'Adicionar à sacola' : 'Esgotado');
    raiz.querySelector('[data-fv-barra]')?.classList.toggle('is-esgotado', !t.ok);
  }

  /* ── Escolher um tamanho ───────────────────────────────────────────────── */
  function escolher(i) {
    const t = tams[i];
    const d = LACRADO ? null : DOSES[i];
    if (!t || !t.v || (!LACRADO && !d)) return;

    todos('.fv-pdp__tam').forEach((b, j) => b.setAttribute('aria-checked', String(j === i)));
    todos('.fv-pdp__rende-botao').forEach((b, j) => b.setAttribute('aria-pressed', String(j === i)));
    todos('.fv-pdp__barra-pilula').forEach((b, j) => b.setAttribute('aria-checked', String(j === i)));
    todos('[data-fv-dose]').forEach((el, j) => el.classList.toggle('is-ativo', j === i));
    const select = raiz.querySelector('[data-fv-select]');
    if (select) select.value = String(i);

    texto('[data-fv-ml]', d ? d.ml : t.ml);
    if (d) {
      texto('[data-fv-borrifadas]', d.borr);
      texto('[data-fv-frasco-de]', d.frasco);
    }

    const frasco = d && raiz.querySelector('[data-fv-frasco]');
    if (frasco) {
      frasco.style.setProperty('--fv-escala', d.frasco === '15 ml' ? '1' : '0.8136');
      frasco.setAttribute('aria-label', `${d.ml} de perfume no frasco de ${d.frasco}`);
      frasco.querySelectorAll('[data-fv-liquido]').forEach((r) => {
        r.setAttribute('y', d.y);
        r.setAttribute('height', d.h);
      });
      const topo = frasco.querySelector('[data-fv-liquido-topo]');
      if (topo) topo.setAttribute('y', d.y);
    }

    texto('[data-fv-pix]', brl(noPix(t.p)));
    texto('[data-fv-preco]', brl(t.p));
    texto('[data-fv-parc]', `${PARCELAS}x de ${brl(Math.round(t.p / PARCELAS))}`);
    const linhaDe = raiz.querySelector('[data-fv-de-linha]');
    if (linhaDe) linhaDe.hidden = !(t.d > t.p);
    if (t.d > t.p) texto('[data-fv-de]', brl(t.d));

    const campo = raiz.querySelector('[data-fv-variante]');
    if (campo) campo.value = String(t.v);
    mostrarAviso(t);
    apertarBarra();

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', t.v);
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (erro) {
      /* Endereço fora do padrão: fica como está. */
    }
  }

  const inicial = tams.findIndex((t) => String(t.v) === raiz.querySelector('[data-fv-variante]')?.value);
  todos('[data-fv-dose]').forEach((el, j) => el.classList.toggle('is-ativo', j === inicial));
  if (tams[inicial] && tams[inicial].v) mostrarAviso(tams[inicial]);

  /* ── Galeria: a foto ou o tamanho escolhido no frasco ──────────────────── */
  function mostrarVista(nome) {
    todos('[data-fv-vista]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.fvVista === nome)));
    todos('[data-fv-vista-painel]').forEach((p) => { p.hidden = p.dataset.fvVistaPainel !== nome; });
  }

  /* ── Quantidade ────────────────────────────────────────────────────────── */
  function quantidade(passo) {
    const campo = raiz.querySelector('[data-fv-qtd-campo]');
    if (!campo) return;
    const q = Math.min(10, Math.max(1, (Number(campo.value) || 1) + passo));
    campo.value = String(q);
    texto('[data-fv-qtd-valor]', String(q));
    const menos = raiz.querySelector('[data-fv-qtd="-1"]');
    if (menos) menos.disabled = q <= 1;
    const mais = raiz.querySelector('[data-fv-qtd="1"]');
    if (mais) mais.disabled = q >= 10;
  }

  /* ── «Escrever uma avaliação»: a janela do formulário do ERP ───────────
     [dono, 21/10] O site sem o Judge.me: quem avalia informa o número do
     pedido e o e-mail da compra, e só vale nota de perfume do pedido — toda
     avaliação nova é compra verificada. «Não faz mais sentido abrir um
     pop-up?» Faz: o botão abre a janela (snippets/frenesi-avaliar-form) ali
     mesmo, com o perfume da página primeiro, e o script do formulário só
     carrega no primeiro clique. Sem a janela, ou se o script não vier, a
     página /pages/avaliar, como antes. */
  const janelaDeAvaliar = document.querySelector('[data-fv-avaliar-janela]');
  let scriptDoFormulario = null;

  function irParaAPagina() {
    const raizDaLoja = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const handle = raiz.dataset.handle || '';
    window.location.href = `${raizDaLoja}pages/avaliar${handle ? `?produto=${encodeURIComponent(handle)}` : ''}`;
  }

  function carregarFormulario() {
    if (window.FrenesiAvaliar) return Promise.resolve();
    if (!scriptDoFormulario) {
      scriptDoFormulario = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = janelaDeAvaliar.dataset.script;
        s.onload = () => resolve();
        s.onerror = () => {
          scriptDoFormulario = null;
          reject(new Error('o formulário de avaliação não carregou'));
        };
        document.head.appendChild(s);
      });
    }
    return scriptDoFormulario;
  }

  function escrever() {
    if (!janelaDeAvaliar || typeof janelaDeAvaliar.showModal !== 'function' || !janelaDeAvaliar.dataset.script) {
      irParaAPagina();
      return;
    }
    janelaDeAvaliar.showModal();
    // O foco fica na própria janela: sem acender o X nem abrir o teclado do celular.
    janelaDeAvaliar.focus({ preventScroll: true });
    document.documentElement.classList.add('fv-janela-aberta');
    carregarFormulario().then(
      () => window.FrenesiAvaliar.iniciar(janelaDeAvaliar.querySelector('[data-frenesi-avaliar]')),
      () => {
        janelaDeAvaliar.close();
        irParaAPagina();
      },
    );
  }

  if (janelaDeAvaliar) {
    // Fecha no X e no clique fora do quadro (o fundo escuro é o próprio <dialog>).
    janelaDeAvaliar.addEventListener('click', (e) => {
      const alvo = e.target instanceof Element ? e.target : null;
      if (alvo === janelaDeAvaliar || alvo?.closest('[data-fv-avaliar-fechar]')) janelaDeAvaliar.close();
    });
    janelaDeAvaliar.addEventListener('close', () => document.documentElement.classList.remove('fv-janela-aberta'));
  }

  raiz.addEventListener('click', (e) => {
    const alvo = e.target instanceof Element ? e.target : null;
    if (!alvo) return;
    const tam = alvo.closest('[data-fv-escolher]');
    if (tam && !tam.disabled) {
      escolher(Number(tam.dataset.fvEscolher));
      return;
    }
    const vista = alvo.closest('[data-fv-vista]');
    if (vista) {
      mostrarVista(vista.dataset.fvVista);
      return;
    }
    const qtd = alvo.closest('[data-fv-qtd]');
    if (qtd) {
      quantidade(Number(qtd.dataset.fvQtd));
      return;
    }
    if (alvo.closest('[data-fv-escrever]')) {
      escrever();
      return;
    }
    if (alvo.closest('[data-fv-barra-adicionar]')) {
      const esgotado = raiz.querySelector('[data-fv-barra]')?.classList.contains('is-esgotado');
      raiz.querySelector(esgotado ? '.fv-pdp__avise' : '[data-fv-adicionar]')?.click();
    }
  });

  raiz.querySelector('[data-fv-select]')?.addEventListener('change', (e) => escolher(Number(e.target.value)));

  /* ── A barra de compra: aparece quando o botão de compra sai da tela por
     cima (no celular e no computador) e some quando ele volta ──────────── */
  const barra = raiz.querySelector('[data-fv-barra]');
  const acoes = raiz.querySelector('.fv-pdp__acoes');
  if (barra && acoes && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entrada]) => {
      barra.hidden = entrada.isIntersecting || entrada.boundingClientRect.top > 0;
      apertarBarra();
    }).observe(acoes);
    window.addEventListener('resize', apertarBarra, { passive: true });
  }

  /* [dono, 21/10] No celular, quando a linha do preço não cabe (preço alto
     ou tela estreita), sai o «ou R$ … no cartão» e o preço no Pix fica inteiro. */
  function apertarBarra() {
    const b = raiz.querySelector('[data-fv-barra]');
    if (!b || b.hidden) return;
    b.classList.remove('is-apertada');
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const preco = b.querySelector('.fv-pdp__barra-preco');
    if (preco && preco.scrollWidth > preco.clientWidth + 1) b.classList.add('is-apertada');
  }

  /* ── Perfil olfativo e pirâmide (curadoria do ERP) ─────────────────────── */
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const maiuscula = (t) => { t = String(t || '').trim(); return t.charAt(0).toUpperCase() + t.slice(1); };

  const medidor = (nome, par) => {
    if (!par || par[0] == null) return '';
    const nivel = Number(par[0]) || 0;
    let partes = '';
    for (let k = 0; k < 5; k += 1) {
      const cheio = Math.max(0, Math.min(1, nivel - k)) * 100;
      partes += `<span style="background: linear-gradient(90deg, #B8913A ${cheio}%, #E8E1D3 ${cheio}%);"></span>`;
    }
    return `<div class="fv-pdp__perfil-linha"><div class="fv-pdp__perfil-rot"><span>${esc(nome)}</span><b>${esc(par[1] || '')}</b></div>` +
      `<div class="fv-pdp__barras" role="img" aria-label="${esc(nome)}: ${esc(par[1] || nivel + ' de 5')}">${partes}</div></div>`;
  };

  /* Ícone de cada ocasião (escolha do dono, 19/10: lista em duas colunas,
     sem dourado). Vale a palavra que aparece primeiro no texto: «Eventos
     especiais e clima frio» é estrela, «Clima frio e ocasiões especiais» é
     floco. «Evento» sozinho diz pouco: só vira estrela quando nada mais
     dá a pista («Eventos formais» é gravata). Sem palavra conhecida: o brilho. */
  const TRACO = (d) => `<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${d}</svg>`;
  const ICONES_OCASIAO = {
    lua: '<path d="M20 14.6A8 8 0 0 1 9.4 4a8 8 0 1 0 10.6 10.6Z"/>',
    coracao: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10Z"/>',
    taca: '<path d="M8 3h8l-.5 5.2a3.5 3.5 0 0 1-7 0Z"/><path d="M12 11.7V20M8.5 20h7"/>',
    gravata: '<path d="M3 8.5 10 11v2l-7 2.5Z"/><path d="M21 8.5 14 11v2l7 2.5Z"/><rect x="10" y="10.4" width="4" height="3.2" rx="1"/>',
    estrela: '<path d="m12 3 2.6 5.4 5.9.8-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8-4.3-4.1 5.9-.8Z"/>',
    maleta: '<rect x="3" y="7.5" width="18" height="12.5" rx="2"/><path d="M8.5 7.5V5.5a1.5 1.5 0 0 1 1.5-1.5h4a1.5 1.5 0 0 1 1.5 1.5v2M3 12.5h18"/>',
    xicara: '<path d="M4.5 9.5h12v4.5a5 5 0 0 1-5 5h-2a5 5 0 0 1-5-5Z"/><path d="M16.5 11h1.3a2.5 2.5 0 0 1 0 5h-1.6M8.5 3.5v3M12.5 3.5v3"/>',
    sol: '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4"/>',
    floco: '<path d="M12 2.5v19M3.8 7.2l16.4 9.6M3.8 16.8l16.4-9.6"/><path d="m9.5 4.2 2.5 2 2.5-2M9.5 19.8l2.5-2 2.5 2"/>',
    folha: '<path d="M5 19c0-8 5-13 15-14-1 10-6 15-14 15"/><path d="M5 19 13 11"/>',
    halter: '<path d="M6.5 7v10M17.5 7v10M3.5 9.5v5M20.5 9.5v5M6.5 12h11"/>',
    pena: '<path d="M4 20l4-1 11-11a2.8 2.8 0 0 0-4-4L4 15Z"/><path d="M13.5 5.5l4 4"/>',
    brilho: '<path d="M12 3c.6 4.2 2.8 6.4 7 7-4.2.6-6.4 2.8-7 7-.6-4.2-2.8-6.4-7-7 4.2-.6 6.4-2.8 7-7Z"/><path d="M19 3.5v3M17.5 5h3"/>',
  };
  const PALAVRAS_OCASIAO = [
    [/jantar/, 'taca'],
    [/encontro|rom[aâ]ntic|sedu|[ií]ntim/, 'coracao'],
    [/formal|elegan|sofistic|refinad|exclusiv/, 'gravata'],
    [/festa|balada|noitada|especia|marcante|destaque|presen[cç]a|impressionar/, 'estrela'],
    [/trabalho|escrit[oó]rio|profission|reuni|neg[oó]cio/, 'maleta'],
    [/academia|esport|treino/, 'halter'],
    [/assinatura/, 'pena'],
    [/uso di[aá]rio|dia a dia|cotidian|casual|vers[aá]til|informa/, 'xicara'],
    [/noite|noturn/, 'lua'],
    [/frio|frias|inverno/, 'floco'],
    [/quente|ver[aã]o|ensolarad|tropical|praia|calor|\bdias?\b|diurn/, 'sol'],
    [/ameno|primavera|outono|esta[cç]/, 'folha'],
    [/passeio|ar livre|lazer|viage|f[eé]rias|descontra/, 'folha'],
  ];
  const iconeOcasiao = (texto) => {
    const t = texto.toLowerCase();
    let melhor = /evento/.test(t) ? 'estrela' : 'brilho';
    let onde = Infinity;
    PALAVRAS_OCASIAO.forEach(([re, nome]) => {
      const m = t.search(re);
      if (m >= 0 && m < onde) {
        onde = m;
        melhor = nome;
      }
    });
    return TRACO(ICONES_OCASIAO[melhor]);
  };

  const CAMADAS = [
    ['s', 'Notas de saída', 'o primeiro contato', '62%', '#FBF7F0'],
    ['c', 'Notas de coração', 'aparecem em seguida', '80%', '#F4EADB'],
    ['b', 'Notas de fundo', 'permanecem por horas', '100%', '#EADBC0'],
  ];

  fetch(raiz.dataset.fonte)
    .then((r) => (r.ok ? r.json() : null))
    .then((todas) => {
      if (!todas) return;
      const f = todas[raiz.dataset.handle];
      const genero = raiz.dataset.genero || '';

      /* Família nas indicações de «também ama», no lugar do selo. */
      raiz.querySelectorAll('.fv-pdp__rel [data-fv-cartao]').forEach((c) => {
        const h = (c.dataset.url || '').split('/products/')[1];
        const fam = h && todas[h] && todas[h].f;
        const foto = c.querySelector('.fv-cartao__foto');
        if (fam && foto && !foto.querySelector('.fv-cartao__selo')) {
          foto.insertAdjacentHTML('beforeend', `<span class="fv-cartao__selo fv-cartao__selo--familia">${esc(maiuscula(fam))}</span>`);
        }
      });

      if (!f) return;

      const sub = raiz.querySelector('[data-fv-sub]');
      if (sub && f.f) sub.textContent = [genero, maiuscula(f.f)].filter(Boolean).join(' · ');

      const perfil = raiz.querySelector('[data-fv-perfil]');
      if (perfil) {
        let html = '';
        if (f.f) {
          const familia = maiuscula(f.f) + (genero ? ' ' + genero.toLowerCase() : '');
          html += `<div class="fv-pdp__perfil-linha fv-pdp__perfil-linha--familia"><span>Família</span><b>${esc(familia)}</b></div>`;
        }
        html += medidor('Intensidade', f.i) + medidor('Fixação', f.x) + medidor('Projeção', f.p);
        if (f.o) {
          const ocasioes = String(f.o).split(',').map((o) => maiuscula(o)).filter(Boolean);
          html += `<div class="fv-pdp__perfil-ocas"><span>Ocasiões</span><ul role="list">${ocasioes.map((o) => `<li><span class="fv-pdp__ocas-ic">${iconeOcasiao(o)}</span>${esc(o)}</li>`).join('')}</ul></div>`;
        }
        if (html) {
          perfil.querySelector('[data-fv-perfil-corpo]').innerHTML = html;
          perfil.hidden = false;
          raiz.querySelector('[data-fv-sobre]')?.classList.add('tem-perfil');
        }
      }

      const piramide = raiz.querySelector('[data-fv-piramide]');
      if (piramide) {
        const base = raiz.dataset.fotos;
        let html = '';
        CAMADAS.forEach(([chave, nome, quando, largura, fundo]) => {
          const notas = f[chave] || [];
          if (!notas.length) return;
          html += `<div class="fv-pdp__camada" style="width: ${largura}; background: ${fundo};">` +
            `<p class="fv-olho">${nome} <span class="fv-pdp__quando"><span class="fv-so-pc">· </span>${quando}</span></p><ul class="fv-pdp__notas" role="list">`;
          notas.forEach(([id, n]) => {
            const rotulo = maiuscula(n);
            html += `<li class="fv-pdp__nota-i"><span class="fv-pdp__foto" data-inicial="${esc(rotulo.charAt(0))}">` +
              `<img src="${base}${id}.webp" alt="" loading="lazy" width="68" height="68"></span><span class="fv-pdp__nota-nome">${esc(rotulo)}</span></li>`;
          });
          html += '</ul></div>';
        });
        if (html) {
          piramide.querySelector('[data-fv-camadas]').innerHTML = html;
          piramide.querySelectorAll('.fv-pdp__foto img').forEach((img) => {
            img.addEventListener('error', () => img.parentElement.classList.add('sem-foto'), { once: true });
          });
          piramide.hidden = false;
        }
      }
    })
    .catch(() => {});
})();
